import { Drawer } from '@packages/fenrir/components';

import { DrawerType, useActionDrawer } from './action-drawer-context';

type ActionDrawerProps = {
  container: HTMLElement | null;
  drawerWidth?: 300 | 500;
};

// TODO: This is an intemediary component that will be removed and transitioned to use the Info Panel (https://arcticwolf.atlassian.net/browse/S2CX-12408)
// When the Info Panel is ready, all components using the Action Drawer will be updated via https://arcticwolf.atlassian.net/browse/MR-4296
export const ActionDrawer: React.FC<ActionDrawerProps> = ({
  container,
  drawerWidth = 500,
}) => {
  const { drawerState, closeDrawer } = useActionDrawer();
  const isFullHeight = drawerState.drawerType === DrawerType.FULL_HEIGHT_DRAWER;
  const children = drawerState.content;
  return (
    <Drawer
      open={drawerState.isOpen}
      onClose={closeDrawer}
      anchor="right"
      disablePortal={true}
      transitionDuration={0}
      ModalProps={{
        container,
        style: isFullHeight ? {} : { position: 'absolute' },
        disableScrollLock: true,
        disableEnforceFocus: true,
      }}
      hideBackdrop={!isFullHeight}
      slotProps={{
        paper: {
          sx: {
            position: 'absolute',
            boxSizing: 'border-box',
            width: drawerWidth,
          },
        },
      }}
    >
      {children}
    </Drawer>
  );
};
